import { render, staticRenderFns } from "./Task_LeavingStudent.vue?vue&type=template&id=0764fb9e&scoped=true&"
import script from "./Task_LeavingStudent.vue?vue&type=script&lang=js&"
export * from "./Task_LeavingStudent.vue?vue&type=script&lang=js&"
import style0 from "./Task_LeavingStudent.vue?vue&type=style&index=0&id=0764fb9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0764fb9e",
  null
  
)

export default component.exports